import { FilterType } from '../../reportsTypes';
import { ReportFilterType } from '../../utils';

/**
 * Infer the filter type based on the current filter value.
 * Ensures quick create / wizard stay in sync when switching tabs.
 */
export function detectFilterTypeFromValue(
  filter: ReportFilterType | null | undefined,
): FilterType {
  if (!filter) {
    return 'normal';
  }

  if (Array.isArray(filter)) {
    return 'ship';
  }

  if (typeof filter === 'string') {
    return 'shiplist';
  }

  if (typeof filter === 'object') {
    const values = Object.values(filter);
    const hasArray = values.some((value) => Array.isArray(value));
    const hasObject = values.some(
      (value) => value && typeof value === 'object' && !Array.isArray(value),
    );

    if (hasArray && hasObject) {
      return 'combined';
    }

    if (hasArray) {
      return 'ship';
    }
  }

  return 'normal';
}
